import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  getCookieString(key: string): string | null {
    return this.getCookie(key);
  }

  setCookieString(key: string, value: string, days?: number): void {
    this.setCookie(key, value, days);
  }

  deleteCookie(name: string) {
    this.setCookie(name, '', -1);
  }

  private getCookie(name: string): string | null {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

  setCookie(name: string, value: string, days?: number) {
    this.setCookieWrapper(
      getCookieText({
        name,
        value,
        days,
        domain: name === 'language' ? getCookieDomain() : undefined,
      })
    );
  }

  // exposing this function for testing purposes only
  setCookieWrapper(cookie: string): void {
    document.cookie = cookie;
  }
}

// expires=null creates a session cookie
const getExpiresDateString = (days: number | undefined): string | null =>
  days ? getDatePlusDays(days).toUTCString() : null;

const getDatePlusDays = (nbDays: number): Date =>
  new Date(new Date().setDate(new Date().getDate() + nbDays));

interface CookieTextParams {
  name: string;
  value: string;
  days?: number;
  domain?: string;
}

const getCookieText = ({ name, value, days, domain }: CookieTextParams): string =>
  `${name}=${value}; path=/; expires=${getExpiresDateString(days)};${domain ? ` domain=${domain};` : ``}`;

// match "jobcloud" and everything after it to share cookies between the main app and auth app
const getCookieDomain = (): string =>
  window.location.hostname.match(/jobcloud\..+/)?.[0] ?? 'jobcloud.ch';
